import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'subtract' })
export class SubtractPipe implements PipeTransform {
  transform(figures: [number | string, number | string]): number {
    return Number(figures[0]) - Number(figures[1]);
  }
}
